import { useRootSelector } from "screens/Root/hooks/useAppSelector";
import { useEffect } from "react";
import { updateQueryStringParameter } from "meta/utils/url";
import { isDevelopmentMode } from "../utils/constants";
export const useDeveloperMode = () => {
    const { isLogged, appSettings } = useRootSelector();
    useEffect(() => {
        const Navigation = window.RootAPI.Navigation;
        if (!isDevelopmentMode) {
            return;
        }
        if (isLogged) {
            const query = window.parent.location.search;
            const params = new URLSearchParams(query);
            const menuId = params.get("menuId");
            const visId = params.get("visId");
            if (menuId) {
                if (visId) {
                    Navigation.openPatientDetail(visId, menuId);
                }
                else {
                    const menuItem = appSettings.StaticData.MenuItems[menuId.toLowerCase()];
                    const url = updateQueryStringParameter(menuItem.Url, "menuId", menuId);
                    Navigation.openContentUrl(url, menuItem.Title);
                }
            }
        }
    }, [isLogged, isDevelopmentMode]);
};
